import { ComponentStyleConfig } from '@chakra-ui/react';
import { BorderWidths, Colors, Radii, Shadows, Space, Sizes } from '../../types';

// Droppable styles
const DroppableStyle = {
  borderWidth: BorderWidths.XS,
  borderColor: Colors.BORDER_MUTED,
  borderRadius: Radii.XL,
};
const DroppableBoxStyle = {
  maxW: Sizes.MD,
  rounded: Sizes.XL,
  bg: Colors.SURFACE_HOVER,
  padding: Space.SM,
};

// Draggable styles
const DraggableStyle = {
  borderColor: Colors.BORDER_DEFAULT,
  borderRadius: Radii.MD,
  borderWidth: BorderWidths.XS,
  boxShadow: Shadows.MD,
  color: Colors.TEXT_EMPHASIS,
  py: Space.XS,
  px: Space.SM,
  my: Space.XS,
  bg: Colors.SURFACE_PAGE,
  _active: {
    bg: Colors.SURFACE_ELEVATED_HOVER,
    borderColor: Colors.BORDER_EMPHASIS,
    boxShadow: Shadows.OUTLINE,
  },
  _focusVisible: {
    outline: 'none',
    borderColor: Colors.BORDER_EMPHASIS,
    boxShadow: Shadows.XL,
  },
  _focus: {
    boxShadow: Shadows.OUTLINE,
  },
  _hover: {
    boxShadow: Shadows.LG,
    zIndex: 'banner',
    bg: Colors.SURFACE_ELEVATED,
    color: Colors.TEXT_EMPHASIS,
    borderColor: Colors.BORDER_MUTED,
  },
};

export const DragAndDrop: ComponentStyleConfig = {
  baseStyle: {
    ...DraggableStyle,
  },
};
export const DropZoneStyle: ComponentStyleConfig = {
  baseStyle: {
    ...DroppableStyle,
    ...DroppableBoxStyle,
  },
};
